var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8303 16.928L1.83027 17.081L1.96354 17.156L13.5216 23.6609L13.6495 23.7329L13.7775 23.6612L23.7634 18.0738V19.7868L13.6503 25.4953L2.81305 19.3345L2.68649 19.2626L2.55866 19.3323L1.96768 19.6544L1.83135 19.7287V19.884V20.6894V20.8423L1.96457 20.9173L13.5216 27.4233L13.6498 27.4955L13.7781 27.4233L25.3361 20.9194L25.4694 20.8444V20.6915V16.176V16.028L25.3424 15.9518L24.8037 15.6286L24.6731 15.5502L24.5404 15.6252L13.6506 21.788L3.59068 16.0245V14.3115L13.5216 19.8975L13.6499 19.9696L13.7781 19.8975L25.3361 13.3936L25.4694 13.3186V13.1657V8.70252V8.55422L25.3421 8.4781L24.8034 8.15594L24.6728 8.07784L24.5404 8.15279L13.6498 14.316L4.39775 9.08012L13.6502 3.84403L21.6384 8.34047L21.7725 8.41599L21.9037 8.33531L22.6024 7.90541L22.7268 7.82883V7.6827V7.09067V6.93834L22.5943 6.8632L13.7788 1.86448L13.6498 1.79132L13.5208 1.86452L1.96275 8.42279L1.8303 8.49794V8.65023V9.40333V9.55625L1.96357 9.63123L13.5216 16.1341L13.6495 16.206L13.7775 16.1344L23.7634 10.547V12.3123L13.6503 18.025L2.81305 11.8642L2.68649 11.7922L2.55866 11.8619L1.96768 12.1841L1.83138 12.2584L1.83135 12.4136L1.8303 16.928Z",
    fill: "#777777",
    stroke: "#777777",
    strokeWidth: 0.522988
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterials);
export default __webpack_public_path__ + "static/media/materials.7042659a7756f94834ce30c46d594aef.svg";
export { ForwardRef as ReactComponent };